/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Olive_Warm_Deer_SkipInputs */

const en_olive_warm_deer_skip = /** @type {(inputs: Olive_Warm_Deer_SkipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Add all available (${i?.count})`)
};

const de_olive_warm_deer_skip = /** @type {(inputs: Olive_Warm_Deer_SkipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alle verfügbaren hinzufügen (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Add all available ({count})" |
*
* @param {Olive_Warm_Deer_SkipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const olive_warm_deer_skip = /** @type {((inputs: Olive_Warm_Deer_SkipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Olive_Warm_Deer_SkipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_olive_warm_deer_skip(inputs)
	return de_olive_warm_deer_skip(inputs)
});